import React from 'react';
interface IconProps {
  className?: string;
  size?: number;
}
const defaultClass = 'text-accent-primary';
// Circular wax seal with 'M' monogram and flame
export function DirectAccessSealIcon({
  className = defaultClass,
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-522">
      {/* Ribbon tails */}
      <path d="M8 17L5.5 22" strokeWidth="0.8" data-id="element-523" />
      <path d="M16 17L18.5 22" strokeWidth="0.8" data-id="element-524" />
      {/* Scalloped seal edge */}
      <path d="M12 3C13.4 3 14 4 14.8 4.2C15.6 4.4 16.6 3.7 17.3 4.4C18 5.1 17.3 6.1 17.5 6.9C17.7 7.7 18.7 8.2 18.7 9.1C18.7 10 17.7 10.5 17.5 11.3C17.3 12.1 18 13.1 17.3 13.8C16.6 14.5 15.6 13.8 14.8 14C14 14.2 13.4 15.2 12 15.2C10.6 15.2 10 14.2 9.2 14C8.4 13.8 7.4 14.5 6.7 13.8C6 13.1 6.7 12.1 6.5 11.3C6.3 10.5 5.3 10 5.3 9.1C5.3 8.2 6.3 7.7 6.5 6.9C6.7 6.1 6 5.1 6.7 4.4C7.4 3.7 8.4 4.4 9.2 4.2C10 4 10.6 3 12 3z" fill="currentColor" fillOpacity="0.12" data-id="element-525" />
      {/* Inner circle */}
      <circle cx="12" cy="9.1" r="4" strokeWidth="0.8" data-id="element-526" />
      {/* M monogram */}
      <path d="M9.5 11.5V7L12 9.5L14.5 7V11.5" strokeWidth="0.7" fill="none" data-id="element-527" />
      {/* Small flame above M */}
      <path d="M12 5.8C12 5.8 12.6 5 12.6 4.5C12.6 4 12.3 3.8 12 3.8C11.7 3.8 11.4 4 11.4 4.5C11.4 5 12 5.8 12 5.8z" fill="currentColor" strokeWidth="0" opacity="0.7" data-id="element-528" />
    </svg>;
}
// Flat folio/archive case with clasp
export function ArchiveFolioIcon({
  className = defaultClass,
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-529">
      {/* Folio body */}
      <rect x="4" y="4" width="16" height="16" rx="1" fill="currentColor" fillOpacity="0.06" data-id="element-530" />
      {/* Spine detail */}
      <line x1="7" y1="4" x2="7" y2="20" strokeWidth="0.7" data-id="element-531" />
      {/* Embossed border detail */}
      <rect x="9" y="7" width="10" height="10" rx="0.5" strokeWidth="0.6" opacity="0.5" data-id="element-532" />
      {/* Clasp */}
      <path d="M19 11.5H21V12.5H19" strokeWidth="0.8" data-id="element-533" />
      <circle cx="20" cy="12" r="0.8" fill="currentColor" strokeWidth="0" data-id="element-534" />
      {/* Decorative corner marks */}
      <path d="M10 8L11 8M10 8L10 9" strokeWidth="0.5" opacity="0.4" data-id="element-535" />
      <path d="M18 8L17 8M18 8L18 9" strokeWidth="0.5" opacity="0.4" data-id="element-536" />
      <path d="M10 16L11 16M10 16L10 15" strokeWidth="0.5" opacity="0.4" data-id="element-537" />
      <path d="M18 16L17 16M18 16L18 15" strokeWidth="0.5" opacity="0.4" data-id="element-538" />
    </svg>;
}
// Page with perfect margins (institutional grade)
export function InstitutionalPageIcon({
  className = defaultClass,
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-539">
      {/* Page outline */}
      <rect x="5" y="2" width="14" height="20" rx="0.5" fill="currentColor" fillOpacity="0.04" data-id="element-540" />
      {/* Inner margin lines */}
      <rect x="7" y="5" width="10" height="14" rx="0" strokeWidth="0.5" strokeDasharray="1 1" opacity="0.3" data-id="element-541" />
      {/* Decorative header rule */}
      <line x1="8" y1="6" x2="16" y2="6" strokeWidth="0.8" data-id="element-542" />
      <line x1="10" y1="6.8" x2="14" y2="6.8" strokeWidth="0.5" opacity="0.5" data-id="element-543" />
      {/* Text lines */}
      <line x1="8" y1="9" x2="16" y2="9" strokeWidth="0.6" opacity="0.7" data-id="element-544" />
      <line x1="8" y1="11" x2="15" y2="11" strokeWidth="0.6" opacity="0.7" data-id="element-545" />
      <line x1="8" y1="13" x2="16" y2="13" strokeWidth="0.6" opacity="0.7" data-id="element-546" />
      <line x1="8" y1="15" x2="14" y2="15" strokeWidth="0.6" opacity="0.7" data-id="element-547" />
      <line x1="8" y1="17" x2="15" y2="17" strokeWidth="0.6" opacity="0.7" data-id="element-548" />
    </svg>;
}
// Antique skeleton key with ornate bow
export function EternalAccessIcon({
  className = defaultClass,
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-549">
      {/* Ornate bow (decorative head) */}
      <circle cx="7" cy="8" r="4.5" strokeWidth="0.8" data-id="element-550" />
      <circle cx="7" cy="8" r="2.5" strokeWidth="0.6" data-id="element-551" />
      {/* Cross detail inside bow */}
      <line x1="7" y1="5.5" x2="7" y2="10.5" strokeWidth="0.5" opacity="0.5" data-id="element-552" />
      <line x1="4.5" y1="8" x2="9.5" y2="8" strokeWidth="0.5" opacity="0.5" data-id="element-553" />
      {/* Small decorative dots */}
      <circle cx="7" cy="6" r="0.4" fill="currentColor" strokeWidth="0" opacity="0.5" data-id="element-554" />
      <circle cx="7" cy="10" r="0.4" fill="currentColor" strokeWidth="0" opacity="0.5" data-id="element-555" />
      <circle cx="5" cy="8" r="0.4" fill="currentColor" strokeWidth="0" opacity="0.5" data-id="element-556" />
      <circle cx="9" cy="8" r="0.4" fill="currentColor" strokeWidth="0" opacity="0.5" data-id="element-557" />
      {/* Key shaft */}
      <line x1="11.5" y1="8" x2="21" y2="8" strokeWidth="0.9" data-id="element-558" />
      {/* Key teeth */}
      <path d="M18 8V11.5" strokeWidth="0.8" data-id="element-559" />
      <path d="M20 8V10.5" strokeWidth="0.8" data-id="element-560" />
      <path d="M16 8V10" strokeWidth="0.7" data-id="element-561" />
    </svg>;
}
// Wax-sealed envelope
export function SealedEnvelopeIcon({
  className = defaultClass,
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-562">
      {/* Envelope body */}
      <rect x="3" y="6" width="18" height="13" rx="1" fill="currentColor" fillOpacity="0.04" data-id="element-563" />
      {/* Envelope flap */}
      <path d="M3 7L12 13L21 7" strokeWidth="0.8" data-id="element-564" />
      {/* Inner fold lines */}
      <path d="M3 19L9 13" strokeWidth="0.5" opacity="0.3" data-id="element-565" />
      <path d="M21 19L15 13" strokeWidth="0.5" opacity="0.3" data-id="element-566" />
      {/* Wax seal on flap */}
      <circle cx="12" cy="10" r="2.2" fill="currentColor" fillOpacity="0.15" strokeWidth="0.7" data-id="element-567" />
      <circle cx="12" cy="10" r="1.2" strokeWidth="0.5" data-id="element-568" />
      {/* Small M in seal */}
      <path d="M11 10.5V9.5L12 10.2L13 9.5V10.5" strokeWidth="0.4" fill="none" data-id="element-569" />
    </svg>;
}
// Refined quill nib with ink drop
export function QuillNibIcon({
  className = defaultClass,
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-570">
      {/* Nib body */}
      <path d="M12 3L8 12L12 21L16 12L12 3z" fill="currentColor" fillOpacity="0.06" data-id="element-571" />
      {/* Nib slit */}
      <line x1="12" y1="8" x2="12" y2="18" strokeWidth="0.6" data-id="element-572" />
      {/* Nib shoulders */}
      <path d="M8 12C9 11 11 10 12 10C13 10 15 11 16 12" strokeWidth="0.7" data-id="element-573" />
      {/* Decorative detail at top */}
      <circle cx="12" cy="5" r="1" strokeWidth="0.5" data-id="element-574" />
      {/* Ink drop */}
      <path d="M12 21C12 21 13.5 22 13.5 22.8C13.5 23.4 12.8 24 12 24C11.2 24 10.5 23.4 10.5 22.8C10.5 22 12 21 12 21z" fill="currentColor" fillOpacity="0.4" strokeWidth="0" data-id="element-575" />
    </svg>;
}
// Device silhouettes: iPhone, iPad, Kindle (wider viewBox)
export function DeviceSilhouettesIcon({
  className = 'text-text-secondary',
  size = 72
}: IconProps) {
  return <svg width={size} height={size / 3} viewBox="0 0 72 24" fill="none" stroke="currentColor" strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-576">
      {/* iPhone - tall narrow with notch */}
      <rect x="8" y="3" width="10" height="18" rx="2" data-id="element-577" />
      <path d="M11 4.5H15" strokeWidth="0.5" opacity="0.5" data-id="element-578" />
      <circle cx="13" cy="18" r="1" strokeWidth="0.5" opacity="0.4" data-id="element-579" />

      {/* iPad - wider rectangle */}
      <rect x="26" y="4" width="16" height="16" rx="1.5" data-id="element-580" />
      <circle cx="34" cy="19" r="0.8" strokeWidth="0.5" opacity="0.4" data-id="element-581" />
      <line x1="30" y1="5.5" x2="38" y2="5.5" strokeWidth="0.4" opacity="0.3" data-id="element-582" />

      {/* Kindle - rectangle with page-turn corner */}
      <rect x="50" y="4" width="14" height="16" rx="1" data-id="element-583" />
      <path d="M60 4L64 8" strokeWidth="0.5" opacity="0.4" data-id="element-584" />
      <path d="M60 4V8H64" strokeWidth="0.5" opacity="0.3" fill="currentColor" fillOpacity="0.05" data-id="element-585" />
      {/* Text lines on Kindle */}
      <line x1="52" y1="10" x2="62" y2="10" strokeWidth="0.4" opacity="0.3" data-id="element-586" />
      <line x1="52" y1="12" x2="61" y2="12" strokeWidth="0.4" opacity="0.3" data-id="element-587" />
      <line x1="52" y1="14" x2="62" y2="14" strokeWidth="0.4" opacity="0.3" data-id="element-588" />
      <line x1="52" y1="16" x2="60" y2="16" strokeWidth="0.4" opacity="0.3" data-id="element-589" />
    </svg>;
}
// Refined book spine with digital spark
export function BookSpineIcon({
  className = defaultClass,
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-590">
      {/* Book cover */}
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" strokeWidth="0.8" data-id="element-591" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" fill="currentColor" fillOpacity="0.04" data-id="element-592" />
      {/* Spine detail lines */}
      <line x1="8" y1="6" x2="16" y2="6" strokeWidth="0.6" data-id="element-593" />
      <line x1="8" y1="8" x2="14" y2="8" strokeWidth="0.5" opacity="0.6" data-id="element-594" />
      <line x1="8" y1="10" x2="15" y2="10" strokeWidth="0.5" opacity="0.6" data-id="element-595" />
      {/* Gold diamond spark */}
      <path d="M15 13.5L16 12L17 13.5L16 15z" fill="currentColor" strokeWidth="0" opacity="0.8" data-id="element-596" />
      {/* Subtle radiating lines from spark */}
      <line x1="17.5" y1="12.5" x2="18.2" y2="12" strokeWidth="0.4" opacity="0.4" data-id="element-597" />
      <line x1="17.5" y1="14" x2="18.2" y2="14.5" strokeWidth="0.4" opacity="0.4" data-id="element-598" />
    </svg>;
}
// Refined ownership key with more ornate bow
export function OwnershipKeyIcon({
  className = defaultClass,
  size = 24
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-599">
      {/* Ornate key bow */}
      <circle cx="7" cy="8" r="4" strokeWidth="0.8" data-id="element-600" />
      <circle cx="7" cy="8" r="2" strokeWidth="0.6" data-id="element-601" />
      {/* Cross detail */}
      <line x1="7" y1="6" x2="7" y2="10" strokeWidth="0.5" data-id="element-602" />
      <line x1="5" y1="8" x2="9" y2="8" strokeWidth="0.5" data-id="element-603" />
      {/* Key shaft */}
      <line x1="11" y1="8" x2="21" y2="8" strokeWidth="0.8" data-id="element-604" />
      {/* Key teeth */}
      <line x1="17" y1="8" x2="17" y2="11" strokeWidth="0.7" data-id="element-605" />
      <line x1="19" y1="8" x2="19" y2="10" strokeWidth="0.7" data-id="element-606" />
    </svg>;
}